import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import ContextTutorials from './ContextTutorials';
import TutorialsInfo from './TutorialsInfo';
import Tutorial from './Tutorial';
import { IconButton } from '@projeccions-pdc/react-icon';
import { getLocalizedName } from '../../helpers';
import AppContext from '../../AppContext';


class TutorialViewer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            currentTutorialId: undefined,
        };
    }

    handleOpenTutorial = () => {
        this.setState({ open: true });
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    handleSelectTutorial = (tutorialId) => {
        this.setState({ currentTutorialId: tutorialId });
    }

    handleCloseTutorial = () => {
        this.handleSelectTutorial(undefined);
    }

    renderTutorialsList = (contextInfo, currentLanguage) => {
        return (
            <div>
                <DialogTitle>
                    {`${getLocalizedName(currentLanguage, contextInfo.name)} help`}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {'In this context the following tutorials may be interesting.'}
                        <br />
                        {'Please, choose one:'}
                    </DialogContentText>
                    <div style={{ margin: '10px', color: '#fff' }}>
                        {contextInfo.tutorialIds.map((tutorialId) => {
                            let tutorial = TutorialsInfo[tutorialId];
                            return (
                                <div
                                    key={tutorialId}
                                    style={{
                                        cursor: 'pointer',
                                        // display: 'inline-block',
                                        backgroundColor: tutorial.color,
                                        margin: '5px',
                                        padding: '15px',
                                    }}
                                    onClick={() => this.handleSelectTutorial(tutorialId)}
                                >
                                    {getLocalizedName(currentLanguage, tutorial.name)}
                                </div>
                            );
                        })}
                    </div>
                </DialogContent>
            </div>
        );
    }

    renderTutorial = (currentLanguage) => {
        return (
            <div>
                <DialogTitle>
                    <IconButton name='md-keyboard-backspace' onClick={this.handleCloseTutorial} />
                    {' Tutorial: '}
                    <b>
                        {getLocalizedName(currentLanguage, TutorialsInfo[this.state.currentTutorialId].name)}
                    </b>
                </DialogTitle>
                <DialogContent>
                    <Tutorial
                        tutorialId={this.state.currentTutorialId}
                        fullScreen={this.props.fullScreen}
                        closeTutorial={this.handleCloseTutorial} />
                </DialogContent>
            </div>
        );
    }

    render() {
        let appContext = new AppContext();
        let currentLanguage = appContext.getLanguage();
        let contextInfo = ContextTutorials[this.props.tutorialContextId];
        return (
            <div>
                <div onClick={this.handleOpenTutorial}>
                    {this.props.children}
                </div>
                <Dialog
                    fullScreen={this.props.fullScreen}
                    open={this.state.open}
                    onClose={this.handleClose}
                    maxWidth='xl'
                >
                    {contextInfo !== undefined ?
                        this.state.currentTutorialId === undefined ?
                            this.renderTutorialsList(contextInfo, currentLanguage)
                            :
                            this.renderTutorial(currentLanguage)
                        :
                        `Nothing available --> ${this.props.tutorialContextId}`
                    }
                    {this.props.fullScreen === true &&
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                {'Close'}
                            </Button>
                        </DialogActions>
                    }
                </Dialog>
            </div>
        );
    }
}
TutorialViewer.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
    children: PropTypes.any.isRequired,
    tutorialContextId: PropTypes.string.isRequired,
};

export default withMobileDialog()(TutorialViewer);